export const SMART_INGEST_CARD_IDS = {
  cardId: 'smart-ingest-metrics',
};

export const SMART_INGEST_CARD_TEXT = {
  cardTitle: 'Smart Ingest',
  productionSyncsCountLabel: 'Production syncs',
  productionSyncsTooltip:
    'The count of production syncs includes any sync that has run in the current month.',
  projectBreakdownUrl: '/payments/info/smartIngestUsage',
  testSyncsCountLabel: 'Test syncs',
  testSyncsTooltip: 'Test syncs do not count towards your organization’s sync allotment.',
  warningBannerText:
    'You have reached the maximum number of syncs allowed under your current plan. Please contact your customer success manager for assistance.',
};
